module.exports = __webpack_public_path__ + "img/start-2.5b0f989.png";